import { render, staticRenderFns } from "./BlockType14Grid.vue?vue&type=template&id=3bcf0c54&scoped=true&"
import script from "./BlockType14Grid.vue?vue&type=script&lang=ts&"
export * from "./BlockType14Grid.vue?vue&type=script&lang=ts&"
import style0 from "./BlockType14Grid.vue?vue&type=style&index=0&id=3bcf0c54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcf0c54",
  null
  
)

export default component.exports